import React from "react";
import { PageShell } from "../components/PageShell";
export function Programme() {
  return <PageShell title="Programme du cinquantenaire" intro="Trois jours de vols, d'expositions et de fête à Mieussy, du 23 au 25 juin 2028." data-id="element-195" data-mp="3ftssmzn72j0s" />;
}